import { NotFound } from 'components/common/NotFound';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import ImportDataPage from './pages/ImportDataPage';

function ImportDataFeature() {
  const { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <Redirect to={`${path}/import-data`} />
        </Route>
        <Route exact path={`${path}/import-data`}>
          <ImportDataPage />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
}

export default ImportDataFeature;
